<template>
  <b-pagination class="my-3" v-model="value" :total-rows="rows" :size="this.size" :per-page="this.perPage" @change="change($event)"></b-pagination>
</template>
<script type="text/javascript">
import $ from 'jquery'
export default {
  name: 'FITPagination',
  props: {
    totalRows: { type: [String, Number], required: true },
    perPage: { type: Number, required: true },
    size: String,
    value: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rows() {
      var rows;
      if ($.type(this.totalRows) == 'string') {
        rows = parseInt(this.totalRows);
      } else {
        rows = this.totalRows;
      }
      return rows;
    }
  },
  methods: {
    change(event) {
      this.$emit('input', event);
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Form/FITPagination.vue